import { SessionStats, SessionStatItem } from '@hyggecards/design-system';
import { Stats as StatsType } from '../services/api';

interface StatsProps {
  stats: StatsType | null;
}

function Stats({ stats }: StatsProps) {
  if (!stats) return null;

  const statItems: SessionStatItem[] = [
    { key: 'total', label: 'Total', value: stats.total },
    { key: 'new', label: 'New', value: stats.neverRated, variant: 'new' },
    { key: 'low', label: 'Low (1)', value: stats.lowRated, variant: 'hard' },
    { key: 'medium', label: 'Medium (2)', value: stats.mediumRated, variant: 'medium' },
    { key: 'high', label: 'High (3)', value: stats.highRated, variant: 'easy' },
    { key: 'pass', label: 'Passed', value: stats.passed, variant: 'skip' },
  ];

  return <SessionStats stats={statItems} />;
}

export default Stats;
